export const paths = {
    ROOT: '',
    LOGIN: 'login',
    LOGOUT: 'logout',
    DASHBOARD: 'dashboard'
}